<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="tracking"
      sort-by="po_box"
      class="elevation-1"
      :search="search"
      :itemsPerPage="50"
      :footer-props="{
        itemsPerPageOptions: [20, 50, 100, 1000],
        showFirstLastPage: true
      }"

    >
      <template v-slot:top>
        <v-toolbar flat>
          <h2>Tracking System</h2>
          <v-spacer></v-spacer>

          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>

          <v-spacer></v-spacer>
          <!-- Dialog Create / Edit Item -->
          <v-dialog 
            v-model="dialogEditItem" 
            max-width="800px"
            persistent
            >
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" dark class="mb-2" v-bind="attrs" v-on="on">
                Nueva
              </v-btn>
            </template>
            
            <DialogEditItem  :editedItem=editedItem @closeDialog="close('editItem')" @saveDialog="save" />
          </v-dialog>
          <!-- Dialog Create / Edit Item -->

          <!-- dialog-uploads-file -->
          <v-dialog 
            v-model="dialogLoadFile" 
            max-width="800px"
            persistent
          >

            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="success"
                dark
                class="mb-2 ml-2"
                v-bind="attrs"
                v-on="on"
              >
                Cargar
              </v-btn>
            </template>

            <DialogUploadsFile @closeDialog="close('loadFile')" />
          </v-dialog>
          <!-- dialog-uploads-file -->

          <v-dialog v-model="dialogDelete" max-width="800px">
            <dialog-delete-item 
              :item="editedItem.idens" 
              @closeDialog="close('deleteItem')" 
              @saveDialog="deleteItemConfirm"
            />
          </v-dialog>

          <!-- dialog Factura -->
          <v-dialog v-model="dialogFactura" max-width="600px">
            <v-card light>
              <v-card-title class="headline">
                Listado de facturas para Nro id: {{ computedDialogPobox.idens }}
              </v-card-title>
              <v-card-text>
                <v-container>
                  <!-- Listado de facturas -->
                  <v-row>
                    <v-col cols="12" v-if="facturaPobox.length">
                      Listado de facturas
                      <div
                        v-for="(factura, index) in facturaPobox"
                        :key="index"
                      >
                        <v-btn
                          class="my-1"
                          :href="actionUrlFacturaFile(factura.fileFactura)"
                          target="_blank"
                          color="primary"
                          block
                        >
                          {{ factura.nro_traking }}-{{ index }}
                          <v-spacer> </v-spacer>
                          <small> <v-icon>mdi-download</v-icon></small>
                        </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                  <!-- Listado de facturas -->
                  <v-row>
                    <v-col cols="12">
                      Acciones:
                      <div>
                        <v-btn
                          class="my-1"
                          @click="sendFacturaMail(computedDialogPobox)"
                          target="_blank"
                          color="warning"
                          block
                        >
                          Enviar Correo <v-spacer> </v-spacer>
                          <small> <v-icon>mdi-email</v-icon></small>
                        </v-btn>
                      </div>
                      <div v-if="computedSendMailFactura === true">
                        <v-alert class="mt-2" dense dismissible type="success"
                          >Mail enviado correctamente</v-alert
                        >
                      </div>
                      <div v-else-if="computedSendMailFactura === 'error'">
                        <v-alert class="mt-2" dense dismissible type="error"
                          >Ocurrió un error al momento de enviar el
                          correo</v-alert
                        >
                      </div>
                      <div v-if="statusMail.length">
                        Primer mail enviado el: {{ statusMail[0].sender_date }}
                        <span v-if="statusMail[0].resender_mail">
                          <br />
                          Se ha reenviado
                          {{ statusMail[0].quantity_resender }} avisos. <br />
                          El último enviado fue el
                          {{ statusMail[0].ultimate_date_resender }}
                        </span>
                      </div>

                      <div v-else>
                        No se le ha enviado mail a cliente avisando que debe
                        subir su factura.
                      </div>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="secondary" @click="close('fileFactura')">
                  Cancel
                </v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- dialog Factura -->
        </v-toolbar>
      </template>

      <template v-slot:[`item.fecha_arribo`]="{ item }">
        {{convertDateFormatBD(item.fecha_arribo)}}
      </template>

      <template v-slot:[`item.nro_traking`]="{ item }">
        <div v-if="item.nro_traking"><span class="primary--text"><strong> Nro Tracking: </strong> </span> {{item.nro_traking}}</div>
        <div v-if="item.cliente"><span class="primary--text"><strong> Cliente: </strong> </span> {{item.cliente}}</div>
        <div v-if="item.remite"><span class="primary--text"><strong> Remite: </strong>  </span>{{item.remite}}</div>
        <div v-if="item.guia_hija"><span class="primary--text"><strong> Guia Hija: </strong> </span> {{item.guia_hija}}</div>
      </template>

      <template v-slot:[`item.has_factura`]="{ item }">
        <v-chip
          :color="getHasFacturaColor(item)"
          dark
          @click="actionFacturaItem(item)"
        >
          <v-icon small class="">
            {{ getHasFacturaValue(item.has_factura) }}
          </v-icon>
        </v-chip>
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <v-icon small class="mr-2" @click="editItem(item)"> mdi-pencil </v-icon>
        <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">Reset</v-btn>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import DialogEditItem from '../components/DialogEditItem';
import DialogUploadsFile from '../components/DialogUploadsFile.vue';
import DialogDeleteItem from '../components/DialogDeleteItem.vue';
import { API_URL } from '../service/api';
 
export default {
  components: { 
    DialogEditItem,
    DialogUploadsFile,
    DialogDeleteItem,
    },

  data: () => ({
    search: "",
    dialogEditItem: false,
    dialogDelete: false,
    dialogLoadFile: false,
    dialogFactura: false,
    sendMailFactura: false,
    dialogPobox: "",
    urlFacturaFile: "",

    unidad_peso: [
      { state: "Kilo", abbr: "kg" },
      { state: "Libra", abbr: "lb" },
    ],
    headers: [
      { text: "Po Box", align: "start", sortable: true, value: "po_box" },
      { text: "Identificador", value: "idens", align: "center" },
      { text: "Nro Traking", value: "nro_traking", sortable: true, align: "start"},
      { text: "Bultos", value: "cantidad_bultos", align: "center" },
      { text: "Facturado", value: "has_factura", sortable: true, align: "center" },
      { text: "Fecha Arribo", value: "fecha_arribo", sortable: true, align: "center"},
      { text: "Peso", value: "peso_with_unidad", sortable: true, align: "center" },
      { text: "Acciones", value: "actions", sortable: false, align: "center" },
    ],
    editedIndex: -1,
    editedItem: {
      po_box: "",
      idens: "",
      cantidad_bultos: 0,
      has_factura: false,
      fecha_arribo: "",
      nro_traking: "--",
      peso_with_unidad: '--',
      actions: "",
    },
    defaultItem: {
      po_box: "",
      idens: "",
      cantidad_bultos: 0,
      has_factura: false,
      fecha_arribo: "",
      nro_traking: "--",
      peso_with_unidad: '--',
      actions: "",
    },
    date: new Date().toISOString().substr(0, 10),
  }),

  computed: {
    ...mapState('tracking', [
      "tracking",
      "po_box",
      "facturaPobox",
      "statusMail",
    ]),
    computedDialogPobox() {
      return this.dialogPobox;
    },
    computedSendMailFactura() {
      return this.sendMailFactura;
    }
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.close("deleteItem");
    },
  },

  mounted() {
    this.initialize();
  },

  methods: {
    ...mapActions('tracking', [
      "getStatusMail",
      "sendMailFacturaPoBox",
      "listFacturaPoBox",
      "listTracking",
      "putTracking",
      "postTracking",
      "deleteTracking",
    ]),

    // Adapta el forma de la fecha como requiere BD
    convertDateFormatBD(date) {
      try {
        date = date.split('-');
        return new Date(date[0], date[1]-1, date[2]).toLocaleString().split(' ')[0]
      } catch (error) {
        console.log('Error in converDateFormat', error)
        return ''
      }
    },

    // Obtiene la información de los tracking
    initialize() {
      return this.listTracking();
    },

    // Permite la edición de una fila
    editItem(item) {
      this.editedIndex = this.tracking.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogEditItem = true;
    },

    // Permite borrar un tracking
    deleteItem(item) {
      this.editedIndex = this.tracking.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      this.tracking.splice(this.editedIndex, 1);
      this.close("deleteItem");
      this.deleteTracking(this.editedItem);
    },

    // Funciona que cierra los dialog y en función del cierre permite recargar la información
    close(dialog) {
      switch (dialog) {
        case "editItem":
          this.dialogEditItem = false;
          this.$nextTick(() => {
            this.editedItem = Object.assign({}, this.defaultItem);
            this.editedIndex = -1;
            console.log('editedIndex', this.editedIndex)
          });
          break;
        case "deleteItem":
          this.dialogDelete = false;
          this.$nextTick(() => {
            this.editedItem = Object.assign({}, this.defaultItem);
            this.editedIndex = -1;
          });
          break;
        case "loadFile":
          this.dialogLoadFile = false;
          this.initialize();
          break;
        case "fileFactura":
          this.$store.state.statusMail = [];
          this.sendMailFactura = false;
          this.dialogFactura = false;
          break;
      }
    },

    save() {
      if (this.editedIndex > -1) {
        this.putTracking(
          Object.assign(this.tracking[this.editedIndex], this.editedItem)
        );
      } else {
        this.tracking.push(this.editedItem);
        this.postTracking(this.editedItem);
      }
      this.close("editItem");
    },

    getHasFacturaColor(item) {
      
      return item.has_factura ? "green" : item.has_factura_excel ? "blue" : "red";
    },

    getHasFacturaValue(has_factura) {
      return has_factura ? "mdi-newspaper" : "mdi-email-check";
    },

    actionFacturaItem(item) {
      this.listFacturaPoBox(item);
      this.getStatusMail(item);
      this.dialogPobox = item;
      this.dialogFactura = true;
    },

    actionUrlFacturaFile(fileFactura) {
      const url = API_URL + fileFactura;
      return url;
    },

    async sendFacturaMail(tracking) {
      const response = await this.sendMailFacturaPoBox(tracking);
      this.sendMailFactura = response.success ? true : "error";
    },
  },
};
</script>